export function animate(element: HTMLElement): void {
  const animations = document.querySelectorAll('.anim');

  const observer = new IntersectionObserver((entries: any) => {
    entries.map((entry: any) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: "-32px"
  });

  animations.forEach(anim => observer.observe(anim));
}